import React from 'react';
import ModalConfirmationComponent from './modal-confirmation.component';

function ModalConfirmation(props) {
    return <ModalConfirmationComponent {...props} />;
}

export default ModalConfirmation;
